import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './ibcartao.css';
import Loading from "./components/loading"
import { LEAD_API_URL, sendEvent } from './Config';

function validarCPF(cpf) {
    cpf = cpf.replace(/\D/g, '');

    if (cpf.length !== 11 || /^(\d)\1+$/.test(cpf)) {
        return false;
    }

    function calcularDigito(cpfParcial, pesoInicial) {
        let soma = 0;
        for (let i = 0; i < cpfParcial.length; i++) {
            soma += parseInt(cpfParcial[i]) * (pesoInicial - i);
        }
        const resto = soma % 11;
        return resto < 2 ? 0 : 11 - resto;
    }

    const digito1 = calcularDigito(cpf.slice(0, 9), 10);
    const digito2 = calcularDigito(cpf.slice(0, 9) + digito1, 11);

    return digito1 === parseInt(cpf[9]) && digito2 === parseInt(cpf[10]);
}

const LoginCPFPage = function () {
    const navigate = useNavigate();
    const [erroCPF, setErroCPF] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const cpfInputRef = useRef();
    const leadIdRef = useRef(localStorage.getItem("lead_id"));

    useEffect(() => {
        const savedCpf = localStorage.getItem("cpf");
        const utmSource = new URLSearchParams(window.location.search).get("utm_source");

        if (utmSource) {
            localStorage.setItem("utm_source", utmSource);
        }

        if (savedCpf && cpfInputRef.current) {
            cpfInputRef.current.value = savedCpf;

            if (validarCPF(savedCpf)) {
                setErroCPF("validated");
            }
        }

        navigator.sendBeacon("/log/coloca_cpf");
        sendEvent(leadIdRef.current ?? false, "br-website-cpf");
    }, []);

    const handleFormSubmit = async (e) => {
        try {
            e.preventDefault();

            const cpf = cpfInputRef.current;
            const cpfDigits = cpf.value.replace(/\D/g, '');

            if (!validarCPF(cpf.value)) {
                setErroCPF("CPF inválido, informe corretamente.")
                return;
            }

            setErroCPF("validated");
            setIsLoading(true);

            localStorage.setItem("cpf", cpfDigits);

            const utmSource = localStorage.getItem("utm_source")
                || new URLSearchParams(window.location.search).get("utm_source")
                || "";

            const response = await fetch(`${LEAD_API_URL}/onboarding/br/${cpfDigits}?utm_source=${encodeURIComponent(utmSource)}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json"
                }
            });

            if (!response.ok) {
                throw new Error(`Erro HTTP: ${response.status}`);
            }

            const json = await response.json();

            if (!json._id) {
                throw new Error("Lead sem _id");
            }

            localStorage.setItem("lead_id", json._id);

            navigate('/onboarding/customer/accept-terms');
        } catch (e) {
            console.error(e.message);
            setErroCPF("Não foi possível continuar. Tente novamente.");
            setIsLoading(false);
        }
    }

    return <>
        {isLoading && <Loading />}
        <div className='header flex items-center'>
            <div className='content flex items-center gap-x-4'>
                <div className='flex items-center w-auto border-r pr-4'>
                    <img src='/assets/img/bb-logo.svg' className='logo' />
                </div>
                <div className='flex-1'>
                    <span className='subtitle'>O cartão mais sofisticado do mercado</span>
                </div>
            </div>
        </div>
        <div className="steps mt-5 flex gap-x-2">
            <div className='flex-1 check'></div>
            <div className='flex-1 check'></div>
            <div className='flex-1'></div>
            <div className='flex-1'></div>
            <div className='flex-1'></div>
            <div className='flex-1'></div>
        </div>
        <div className='container'>
            <form onSubmit={handleFormSubmit}>
                <div className='content mt-8'>
                    <h1>Boa escolha! Para solicitar seu novo cartão, digite seu CPF.</h1>
                    <p className='mt-6 separator-bottom pb-5'>A cada passo suas informações são salvas automaticamente.</p>
                    <div className={`field ${(erroCPF != "" && erroCPF != "validated") ? "error" : ""} ${(erroCPF == "validated") ? "validated" : ""}`}>
                        <input id="cpf" ref={cpfInputRef} className="mt-5 login" type='text' inputMode="numeric" placeholder='CPF' maxLength={14} onInput={(e) => {
                            setErroCPF("");

                            e.target.value = e.target.value.replace(/\D/g, '');
                            e.target.value = e.target.value.replace(/(\d{3})(\d)/, '$1.$2');
                            e.target.value = e.target.value.replace(/(\d{3})(\d)/, '$1.$2');
                            e.target.value = e.target.value.replace(/(\d{3})(\d{1,2})$/, '$1-$2');

                            return e.target.value;
                        }} onBlur={(e) => {
                            if (e.target.value.length == 0) {
                                setErroCPF("Campo obrigatório")
                                return;
                            }

                            if (!validarCPF(e.target.value)) {
                                setErroCPF("CPF inválido, informe corretamente.")
                            } else {
                                setErroCPF("validated");
                            }
                        }} />
                        <label>CPF</label>
                        <img src='/assets/img/warning.svg' className="warning" />
                        <img src='/assets/img/check.svg' className="check" />
                        <span className='error-message'>{erroCPF}</span>
                    </div>
                    <p className='caption mt-12'>Ao continuar você aceita os <a href="#">Termos de Uso e Política de Privacidade</a> do Banco do Brasil.</p>
                    <button type="submit" className='primary w-full mt-12'>Continuar</button>
                </div>
            </form>
        </div>
        <img src='/assets/img/bb-logo.svg' className='d-none' />
    </>
}

export default LoginCPFPage;